import {
  Box,
  Button,
  Grid,
  Icon,
  Input,
  InputGroup,
  InputLeftAddon,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Text,
  useDisclosure,
} from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { FiChevronDown } from 'react-icons/fi'
import { normalizeString } from '../../../utils/normalizeString'
import { useFormContext, useWatch } from 'react-hook-form'
import { firstLetterUpperCaseAndRestLowerCase } from '../../../utils/capitalFirstLetter'
import { useQuery } from 'react-query'
import { baseURL } from '../../../services/api'

export function SelectColorProductPopover() {
  const [filteredColorProduct, setFilteredColorProduct] = useState([])
  const { isOpen, onToggle, onClose } = useDisclosure()
  const {
    setValue,
    formState: { errors },
  } = useFormContext()

  const { data: colors, isLoading: categoryColorsLoading } = useQuery(
    'colors',
    async () => {
      const response = await baseURL.get('/detalhes-produto/listar-cores-gerais')

      return response.data
    },
    {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 60 * 24, // 24 hours
      onSuccess: (data) => {
        setFilteredColorProduct(data)
      },
    }
  )

  const colorSelected = useWatch({ name: 'corproduto' })

  function handleFilterCategory(event) {
    setFilteredColorProduct(colors)
    const filter = event.target.value
    const formattedFilter = normalizeString(filter)

    const filtered = colors.filter((item) => normalizeString(item.nome_cor).includes(formattedFilter))
    setFilteredColorProduct(filtered)
  }

  console.log('color', filteredColorProduct)

  return (
    <Popover placement="bottom-end" returnFocusOnClose={false} isOpen={isOpen} onClose={onClose}>
      <PopoverTrigger>
        <InputGroup>
          <InputLeftAddon children="Cor do produto" width="230px" borderColor={errors?.corproduto ? 'red.500' : '#C5CED6'} />
          <Button
            borderLeftRadius={0}
            borderRightRadius="md"
            bg="transparent"
            w="100%"
            border="1px solid #378BBF"
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            onClick={onToggle}
            borderColor={errors?.corproduto ? 'red.500' : '#378BBF'}
          >
            <Text fontSize="sm" mr="auto">
              {firstLetterUpperCaseAndRestLowerCase(colorSelected?.nome_cor) || 'Selecione a cor do Produto'}
            </Text>
            <Icon as={FiChevronDown} />
          </Button>
        </InputGroup>
      </PopoverTrigger>
      <PopoverContent _focus={{ outline: 'none' }} w="758px">
        <PopoverHeader fontWeight="semibold">
          <Input
            type="text"
            placeholder="O que você está cadastrando?"
            border={0}
            outline="none"
            _focus={{ outline: 'none' }}
            onChange={handleFilterCategory}
          />
        </PopoverHeader>
        <PopoverArrow />
        {/* <PopoverCloseButton /> */}
        <PopoverBody px={0}>
          <Grid
            templateColumns="repeat(3, 1fr)"
            gridGap="2"
            maxH="500px"
            overflowY="auto"
            //estilizar a barra de rolagem
            css={{
              '&::-webkit-scrollbar': {
                width: '4px',
              },
              '&::-webkit-scrollbar-track': {
                width: '6px',
                borderRadius: '3px',
                background: '#F1F1F1',
              },
              '&::-webkit-scrollbar-thumb': {
                background: '#378BBF',
                borderRadius: '3px',
              },
            }}
          >
            {filteredColorProduct?.map((item, index) => (
              <Box
                _hover={{ bg: 'gray.100' }}
                key={index}
                px={4}
                cursor="pointer"
                onClick={() => {
                  setValue('corproduto', item)
                  onClose()
                }}
              >
                <Text textTransform="capitalize" fontSize="14px">
                  {item.nome_cor.toLowerCase()}
                </Text>
              </Box>
            ))}
          </Grid>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  )
}
